import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Title from './Title';
import Text from './Text';
import { palette } from '../../constants/styles';
import Icon from './Icon';

const StyledUl = styled.ul`
  margin: 1rem 0;
`;

const StyledLi = styled.li`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 0;
  align-items: ${({ center }) => (center ? 'center' : '')};
`;


const StyledLiNumber = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledLiText = styled.div`

`;

const Steps = ({
  steps,
  customBullet,
  center,
  style,
}) => (
  <Fragment>
    <StyledUl style={{ listStyle: 'none', padding: '0px', ...style }}>
      {steps.map((step, index) => (
        <StyledLi key={`steps-${step.content}`} center={center}>
          <StyledLiNumber style={{ width: '15%' }}>
            { !customBullet
              ? (<Title level={4} styles={css`margin: 0px`} color={palette.primaryColor} display="inline-block">{`${index + 1}`}</Title>)
              : (<Icon icon={step.icon} size={25} />)
            }
          </StyledLiNumber>
          <StyledLiText style={{ width: '85%' }}>
            <Text type="body1" display="inline-block">{step.content}</Text>
            { step.subtitle && <Text type="caption">{step.subtitle}</Text> }
          </StyledLiText>
        </StyledLi>
      ))}
    </StyledUl>
  </Fragment>
);
Steps.propTypes = {
  style: PropTypes.object,
  center: PropTypes.bool,
  steps: PropTypes.array,
  customBullet: PropTypes.bool,
};

Steps.defaultPropTypes = {
  style: {},
  center: false,
  steps: [],
  customBullet: false,
};

export default Steps;
